import { ConsultantsQueryExpOnlyInput, SelectType } from "@graphql";

export const expOnlyInitialValue: ConsultantsQueryExpOnlyInput = {
  specializations: {
    type: SelectType.ANY,
    value: []
  }
};
